let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ji8HV")).then(() => parcelRequire('fxJe7'));